<template>
    <outboxCon>
        <div class="cooperation-demo">
            <app-title main='合作的成功案例' sub='鼓励中小型机构成长，大型机构进化'></app-title>
            <div class="cooperation-tab" :class="`activeTab-${curType}`">
                <div class="cooperation-tab-item" @click="changeType(item.tab_id)" :class="{ isActive: item.tab_id === curType}" v-for="(item, index) in cooTabList" :key="`co-tab${index}`">
                    <p class="tab-name">{{item.name}}</p>
                    <p class="scale-des">{{item.scale}}</p>
                </div>
            </div>
            <div class="tab-layer"></div>
            <div class="school-box">
                <div class="school-box-item" v-for="(item, index) in scholList" :key="`co-school${index}`">
                    <!-- <img class="school-img" :src="item.img"> -->
                    <p class="school-name">{{item.school_name}}</p>
                    <p class="school-des">{{item.school_des}}</p>
                    <p class="president">{{item.president}}</p>
                    <p class="cocoperation-li">合作时间：{{item.coop_date}}</p>
                    <p class="cocoperation-li">合作模式：{{item.coop_type}}</p>
                </div>
            </div>
            <button class="look-more-btn" @click="lookMore">查看更多成功案例</button>
        </div>
    </outboxCon>
</template>
<script>
import { cooperationDemo } from '@/const/index'
export default {
  data () {
    return {
      curType: 1,
      cooperationDemo: cooperationDemo,
      cooTabList: [
        {
          tab_id: 1,
          name: '中小型机构',
          scale: '学员规模：20-2000人'
        },
        {
          tab_id: 2,
          name: '大型机构',
          scale: '学员规模：2000人以上'
        }
      ]
    }
  },
  computed: {
    scholList () {
      return this.cooperationDemo[this.curType]
    }
  },
  methods: {
    changeType (type) {
      this.curType = type
    },
    lookMore () {
      this.$router.push('/success-info')
    }
  }
}
</script>
<style lang="scss" scoped>
    .cooperation-demo{
        width: $main-width;
        margin: 0 auto;
        padding: 100px 81px 87px;
        position: relative;
        .cooperation-tab{
            margin-top: 56px;
            width: 1170px;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            .cooperation-tab-item{
                padding: 0px 40px;
                color: #959BA6;
                cursor: pointer;
                position: relative;
                .tab-name{
                    font-size:22px;
                    font-family:PingFang SC;
                    font-weight:600;
                    line-height: 22px;
                }
                .scale-des{
                    font-size:14px;
                    font-family:PingFang SC;
                    font-weight:400;
                    line-height: 14px;
                    margin-top: 9px;
                }
                &:hover, &.isActive{
                    color: $base-font-color;
                    position: relative;
                }
            }
            &::after{
                content: ' ';
                display: inline-block;
                width:135px;
                height:4px;
                background:rgba(0,133,255,1);
                border-radius:2px;
                position: absolute;
                left: 50%;
                bottom: -20px;
                margin-left: -67px;
                z-index: 10;
                transform: translateX(-113px);
                transition: transform 1s;
            }
            &.activeTab-2::after{
                transform: translateX(113px);
            }
        }
        .tab-layer{
            margin-top: 16px;
            width:1105px;
            height:4px;
            background: linear-gradient(to right, rgba(255, 255, 255, 1) 0%, #EBEEF5 50%, rgba(255, 255, 255 ,1) 100%);
        }
        .school-box{
            display: flex;
            justify-content: center;
            align-items: flex-start;
            margin-top: 50px;
            .school-box-item{
                width:264px;
                height:360px;
                background:rgba(255,255,255,1);
                border:1px solid rgba(206, 206, 206, 0.6);
                box-shadow:0px 3px 3px 0px rgba(0, 0, 0, 0.03);
                border-radius:10px;
                margin-right: 15px;
                padding: 40px 20px;
                text-align: left;
                transition: transform .5s;
                .school-img{
                    width: 85px;
                    height: 85px;
                    border-radius: 50%;
                    overflow: hidden;
                    display: block;
                    margin: 0 auto 27px;
                }
                .school-name{
                    font-family: PingFangSC-Semibold;
                    font-size: 22px;
                    line-height: 24px;
                }
                .school-des{
                    margin-top: 20px;
                    font-family: PingFangSC-Regular;
                    font-size: 16px;
                    line-height: 28px;
                    height: 140px;
                }
                .president{
                    font-family: PingFangSC-Regular;
                    font-size: 16px;
                    line-height: 24px;
                    text-align: right;
                    margin-bottom: 20px;
                }
                .cocoperation-li{
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    line-height: 20px;
                }
                &:last-of-type{
                    margin-right: 0px;
                }
                &:hover{
                    transform: scaleX(1.06) scaleY(1.06);
                    box-shadow:0px 18px 29px 0px rgba(105,111,127,0.09);
                }
            }
        }
        .look-more-btn{
            display: block;
            margin: 96px auto 0px;
            width:416px;
            height:70px;
            font-size:24px;
            background:rgba(255,255,255,1);
            border:1px solid rgba(206, 206, 206, 0.6);
            box-shadow:0px 5px 5px 0px rgba(0, 0, 0, 0.03);
            border-radius:5px;
            cursor: pointer;
            &:hover{
                color: #fb594a;
            }
            &:active{
                background: rgba(0, 0, 0, 0.03);
                color: #fb594a;
            }
        }
    }
</style>
